import {
  CalendarClock, FileSpreadsheet, FolderSearch, Hourglass, MapPinOff,
  SearchX, ShieldAlert, UserX,
} from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

// Foresee-blue/indigo line icons per the product's visual identity.
const PROBLEM_ICONS = {
  'Paper and Spreadsheet Reporting': FileSpreadsheet,
  'Issues Without Closure': UserX,
  'Limited Multi-Site Visibility': MapPinOff,
  'Disconnected Compliance Records': FolderSearch,
  'Reactive Management': Hourglass,
  'Inconsistent Contractor Control': ShieldAlert,
  'Expiring Training and Documents': CalendarClock,
  'Difficult Audit Preparation': SearchX,
};

// Section 2 — the compliance challenge.
export const ForeseeChallenge = ({ sp }) => (
  <section aria-labelledby="foresee-challenge-heading" data-testid="foresee-challenge" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="02"
        eyebrow="The Challenge"
        title="Reporting an issue is only the beginning"
        description={sp.problemCopy}
        testid="foresee-challenge-header"
      />
      <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {(sp.problems || []).map((problem, i) => {
          const Icon = PROBLEM_ICONS[problem.title] || FileSpreadsheet;
          return (
            <Reveal key={problem.title} delay={(i % 4) * 0.06} className="h-full">
              <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-mist p-6" data-testid={`foresee-problem-${i + 1}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-indigo-200 bg-indigo-50 text-indigo-600">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-base font-extrabold tracking-tight text-navy-900">{problem.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{problem.text}</p>
              </li>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);
